const ticket = {
  createANewTicket: "Create a New Ticket",
  subject: "Subject",
  label: "Label",
  relatedEquipment: "Related Asset",
  notAnEquipment: "None",
  description: "Description",
  submit: "Submit",
  yourTickets: "Your Tickets",
  issues: "Software Ticket",
  mechanicalSupport: "Hardware Ticket",
  suggestions: "Suggestions",
  ticketProfile: "Ticket Profile",
  status: "Status",
  comments: "Comments",
  comment: "Comment",
  addNewComment: "Add New Comment",
  messages: {
    successful: "The ticket was created successfully"
  },
  backbtn: "Go Back",
  modulesbtn: "Modules"
};

export default ticket;
